module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_8003.7f5bce9d.png";